import React from "react";
import SkeletonSpacer from "./SkeletonSpacer";

type Props = {
  numberOfRows: number;
};

const SkeletonGrid = (props: Props) => {
  const cols = 3;
  return (
    <>
      {Array.from({ length: cols }).map((_, col: number) => (
        <div key={col} className="flex gap-2 mb-2">
          {Array.from({ length: props.numberOfRows }).map((_, index) => (
            <div key={index} className="flex-1">
              <SkeletonSpacer />
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default SkeletonGrid;
